App.service('angularChart', function(){
  // used on
  // Payments - stat - Payments growth
  return {
    setGrowthChartConfig(yAxisTicksIsIntegersOnly = true, dataLabelPrefix = null) {
      growthChartColors = ['#7F98DE']
      growthChartOptions = {
        events: false,
        tooltips: {
          enabled: false
        },
        hover: {
          animationDuration: 0
        },
        animation: {
          onComplete: function () {
            var chartInstance = this.chart,
                ctx = chartInstance.ctx;
            ctx.font = Chart.helpers.fontString(Chart.defaults.global.defaultFontSize, Chart.defaults.global.defaultFontStyle, Chart.defaults.global.defaultFontFamily);
            ctx.textAlign = 'center';
            ctx.textBaseline = 'bottom';
            this.data.datasets.forEach(function (dataset, i) {
              var meta = chartInstance.controller.getDatasetMeta(i);
              meta.data.forEach(function (bar, index) {
                var data = dataset.data[index];
                if(data > 0){ // do not show zero values
                  if(dataLabelPrefix){
                    var data = `${dataLabelPrefix}${data}`;
                  }
                  ctx.fillText(data, bar._model.x + 12, bar._model.y - 10);
                }
              });
            });
          }
        },
        scales: {
          yAxes: [
            {
              id: 'y-axis-2',
              type: 'linear',
              display: true,
              position: 'right',
              gridLines: {
                display: false
              },
              ticks: {
                maxTicksLimit: 5,
                min: 0
              }
            },
          ],
          xAxes: [{
            gridLines: {
              display: false
            }
          }]
        }
      }
      if(yAxisTicksIsIntegersOnly){
        growthChartOptions.scales.yAxes[0].ticks.callback = function(value, index, values) {
          if (Math.floor(value) === value) {
            return value
          }
        }
      }
      return [growthChartColors, growthChartOptions]
    },

    statLabels(stat_dates) {
      return _.map(stat_dates, stat_day => {
        date = moment(stat_day)
        weekday = date.format("ddd")
        month_year = date.format("MMM DD")
        return [weekday, month_year]
      })
    },

    increaseMaxYValue(growthChartOptions, maxValue) {
      // set chart's last Patient Growth Chart Y label to max value + 1 so the max value be visible
      growthChartOptions['scales']['yAxes'][0]['ticks']['suggestedMax'] = maxValue + 1
    },

    fullDateRangeOptions() {
      return {
        applyClass: 'btn-green',
        showCustomRangeLabel: false,
        alwaysShowCalendars: true,
        linkedCalendars: false,
        autoApply: true,
        locale: {
          applyLabel: "Apply",
          fromLabel: "From",
          format: "YYYY-MM-DD",
          toLabel: "To",
          cancelLabel: 'Cancel',
          customRangeLabel: 'Custom range'
        },
        ranges: {
          'Today': [
            moment(),
            moment()
          ],
          'This Week': [
            moment().startOf('isoWeek'),
            moment().endOf('isoWeek')
          ],
          'This Month': [
            moment().startOf('month'),
            moment().endOf('month')
          ],
          'This Year': [
            moment().startOf('year'),
            moment().endOf('year')
          ],
          'Yesterday': [
            moment().add(-1, 'days'),
            moment().add(-1, 'days')
          ],
          'Last Week': [
            moment().subtract(1, 'weeks').startOf('isoWeek'),
            moment().subtract(1, 'weeks').endOf('isoWeek')
          ],
          'Last Month': [
            moment().subtract(1, 'month').startOf('month'),
            moment().subtract(1, 'month').endOf('month')
          ],
          'All Time': [
            moment("2010-01-01", "YYYY-MM-DD"),
            moment()
          ]
        },
        eventHandlers: {}
      }
    } 
  }
})
